import { Container, Row } from "reactstrap";
import ButtonsWithPrefixPostfix from "./ButtonsWithPrefixPostfix";
import DefaultTouchspin from "./DefaultTouchspin";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormWidgetsTitle, TouchspinTitle } from "../../../../../Constants/Constants";
import IconsWithPrefixAndPostfix from "./IconsWithPrefixAndPostfix";
import OutlinedTouchspin from "./OutlinedTouchspin";
import RoundedTouchspin from "./RoundedTouchspin";

const TouchspinContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TouchspinTitle} parent={FormWidgetsTitle} />
      <Container fluid>
        <div className="bootstrap-touchspin">
          <Row>
            <DefaultTouchspin />
            <OutlinedTouchspin />
            <IconsWithPrefixAndPostfix />
            <ButtonsWithPrefixPostfix />
            <RoundedTouchspin />
          </Row>
        </div>
      </Container>
    </>
  );
};
export default TouchspinContainer;
